<div
  class="mx-auto flex w-[340px] items-center gap-3 overflow-hidden rounded-lg bg-assistant-welcome p-2"
  data-testid="assistant-chat-window-welcome"
>
  <svg-icon key="px-24-ai-2" size="md" class="shrink-0 text-states-purple-dark"></svg-icon>
  <div class="flex min-w-0 flex-1 flex-col gap-0.5">
    <span class="typo-h7-semibold break-words text-text-black" data-testid="assistant-chat-window-welcome-title">{{ title() }}</span>
    <div
      class="rich-text typo-h7-book text-text-black"
      data-testid="assistant-chat-window-welcome-message"
      libRichText
      [text]="description()"
    ></div>
  </div>
</div>
